import React from 'react';
import { Link } from 'react-router-dom';
import '../css/main.css';

class Home extends React.Component {
  state = {
    loc: '',
  }
  render() {
    return(
      <div>
        <div className="logo_name">
          <div className="logo-img">
            <img src="logo.png" />
          </div>
          <div className="logo_text">
            <h1 className="name">सारथी</h1>
            <h3 class="slogan">Your Travel Partner!</h3>
          </div>
        </div>
        <div>
          <img className="responsive-img" src="./bg-gif.gif" width="1080" height="720" />
        </div>
        <div className="jumbotron">
          <h2>Want to book a hotel...?</h2>
          <Link className="searchButton" to="/hotels">Click here!</Link>
        </div>
      </div>
    );
  }
}

export default Home;
